__turbopack_context__.v({
  "sectionTitle": "sort-by-module-scss-module__jDnUjW__sectionTitle",
  "sortControl": "sort-by-module-scss-module__jDnUjW__sortControl",
});
